import { useState, useEffect } from "react"

const useLazyLoad = (src: string) => {
  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true)
          observer.disconnect()
        }
      },
      {
        threshold: 0.1,
      }
    )

    const imageElement = document.getElementById(src)
    if (imageElement) observer.observe(imageElement)

    return () => {
      if (imageElement) observer.unobserve(imageElement)
    }
  }, [src])

  return isIntersecting
}

export default useLazyLoad
